// @flow
import BaseViewModel from './base';

import type { IViewModel } from '../contracts';

export default class DefaultViewModel
	extends BaseViewModel
	implements IViewModel {
}